import { createFileRoute } from "@tanstack/react-router"
import FilterPresetPage from "@/app/settings/report/filterPreset/page"

export const Route = createFileRoute("/settings/report/filter-preset")({
  component: FilterPresetPage,
})
